<script setup lang="ts">
import {Knowledgeable} from "@/knowledge-box/interfaces";
import KnowledgeableChatModal from "@/knowledge-box/components/KnowledgeableChatModal.vue";
import Icon from "@/core/components/icon/Icon.vue";
import GlowingContainer from "@/core/components/glowing-container/GlowingContainer.vue";

defineProps<{
    knowledgeable: Knowledgeable;
    color?: string;
}>();
</script>

<template>
  <KnowledgeableChatModal :knowledgeable="knowledgeable">
    <template #trigger>
      <GlowingContainer :colors="color ? [color, '#FFFFFF'] : undefined">
        <div
          class="bg-white px-3 py-2 rounded-full flex gap-2 items-center" :style="{
            color: color,
          }"
        >
          <p class="flex-1">
            Poser une question à l'IA
          </p>
          <Icon name="mdi-creation" :color="color" :size="20" />
        </div>
      </GlowingContainer>
    </template>
  </KnowledgeableChatModal>
</template>

<style scoped>
.glowing-container {
    padding: 2px;
    border-radius: 20px;
}

.glowing-container :deep(.content) {
    border-radius: 22px !important;
}
</style>
